import * as React from "react";
import { toast, Button } from "@grandvisionhq/common";
import { Form, Text, Util, Email } from "@grandvisionhq/forms";
import { useFormatter, useLocation } from "@grandvisionhq/frk-routing";
import { sha256 } from "@grandvisionhq/lib-utils-w3c";
import { useIntl } from "@grandvisionhq/state";
import { useLogin } from "../../../../hooks/hooks/use-login.js";
import ErrorMessagesContainer from "../../../ErrorMessages/components/ErrorMessages/ErrorMessagesContainer.js";
/* empty css               */
const LoginForm = ({ isOrderNumberValid }) => {
  const [email, setEmail] = React.useState();
  const [orderNumber, setOrderNumber] = React.useState();
  const [isRedirecting, setIsRedirecting] = React.useState(false);
  const { getLabel } = useIntl();
  const formatter = useFormatter();
  const { push } = useLocation();
  const onError = React.useCallback(() => {
    toast.failed("returns.errors.fetchError");
  }, []);
  const onCompleted = React.useCallback(
    (result) => {
      const hasNoFailures = !!!result.getReturn.failures.length;
      const isReturnable = result.getReturn.return?.status === "RETURNABLE";
      if (hasNoFailures && isReturnable) {
        setIsRedirecting(true);
        push(
          formatter({
            route: "returns.select-items",
            params: { email, orderNumber }
          })
        );
      }
    },
    [email, formatter, orderNumber, push]
  );
  const [trigger, { loading: fetchIsLoading }] = useLogin({ onError, onCompleted });
  const handleSubmit = React.useCallback(
    async ({ formState }) => {
      if (formState.orderNumber && formState.email) {
        try {
          const email2 = await sha256(formState.email.value.toLowerCase());
          const orderNumber2 = formState.orderNumber.value;
          setOrderNumber(orderNumber2);
          if (email2) {
            setEmail(email2);
            trigger({ email: email2, orderNumber: orderNumber2 });
          }
        } catch (error) {
          console.error("Failed to hash email:", error);
          toast.failed("returns.errors.fetchError");
        }
      }
    },
    [trigger]
  );
  const loading = fetchIsLoading || isRedirecting;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorMessagesContainer, null), /* @__PURE__ */ React.createElement(Form, { className: "returns-login-form", name: "returns-login-form", onSubmit: handleSubmit }, /* @__PURE__ */ React.createElement(
    Text,
    {
      id: "orderNumber",
      "data-t": "order-number",
      validations: isOrderNumberValid ? [isOrderNumberValid] : [Util.validations.isOrderNumber],
      label: getLabel("returns.page.login.field.orderNumber"),
      errorMessage: getLabel("returns.page.login.field.orderNumber.errorMessage"),
      disabled: isRedirecting
    }
  ), /* @__PURE__ */ React.createElement(
    Email,
    {
      id: "email",
      label: getLabel("returns.page.login.field.email"),
      errorMessage: getLabel("returns.page.login.field.email.errorMessage"),
      disabled: isRedirecting
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: getLabel("returns.page.login.action.submit"),
      className: "returns-login-form__submit",
      isLoading: loading,
      type: "submit",
      disabled: loading
    }
  )));
};
export {
  LoginForm as default
};
//# sourceMappingURL=LoginForm.js.map
